import { useCallback, useEffect, useState } from "react";
import { getMerchantCategories } from "../api/categoriesApi";

// ─────────────────────────────────────────────────────────────────────────────
// Categories feature — логик (hook). Дэлгэц зөвхөн ҮҮНИЙГ дуудаад рендерлэнэ.
// categories: ангиллын мод, loading/error: төлөв, refetch: дахин ачаалах
// (нэмэх/засах/устгасны дараа window.location.reload() оронд ҮҮГЭЭР шинэчилнэ).
// ─────────────────────────────────────────────────────────────────────────────
export function useCategories() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const refetch = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await getMerchantCategories();
      if (res?.success) {
        setCategories(res.data || []);
      } else {
        setError(res?.message || "Ангилал ачаалж чадсангүй");
      }
    } catch (err) {
      console.error("Ангилал татаж чадсангүй:", err);
      setError("Сервертэй холбогдож чадсангүй");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return { categories, loading, error, refetch };
}
